import { useSelector } from 'react-redux';
import { RootState } from '../ReduxToolkit/Store';

export const usePermissions = () => {
  const currentUser = useSelector((state: RootState) => state.auth.currentUser);

  const hasPermission = (permissionCode: string) => {
    if (!currentUser || !currentUser.permissions) return false;
    return currentUser.permissions.includes(permissionCode);
  };

  const hasAnyPermission = (permissionCodes: string[]) => {
    if (!currentUser || !currentUser.permissions) return false;
    return permissionCodes.some(code => currentUser.permissions.includes(code));
  };

  return { hasPermission, hasAnyPermission, permissions: currentUser?.permissions || [] };
};
